import { ILayerGroup } from "./ILegendLayer";
import { MAP_COLORS } from "../components/ViewerLegend/utils";
import MIKE_COLORS from "../styles/mike-colors";

export const layerGroupTitleBackground = "Hintergrund";
export const layerGroupTitleMeasures = "Maßnahmen";
export const layerGroupTitleOwnAreas = "Eigene Zuständigkeitsgebiete";
export const layerGroupTitleAllAreas = "Andere Zuständigkeitsgebiete";
export const OTHER_EXISTING_MEASURES_ID = "other_existing_measures"
export const NEW_MEASURES_ID = "new_measures"
export const EXISTING_MEASURES_ID = "own_existing_measures"
export const MEASURE_AREA_ID = "measure_area_all"
export const OWN_MEASURE_AREA_ID = "measure_area_own"
export const RIVER_ID = "river"
export const BASEMAP_ID = "basemap"

export const layerOrder = [NEW_MEASURES_ID, OTHER_EXISTING_MEASURES_ID, EXISTING_MEASURES_ID, MEASURE_AREA_ID, OWN_MEASURE_AREA_ID];

export const getLayerOrderIndex = (elementId: string) => {
  const index = layerOrder.findIndex((layer: string) => layer === elementId)
  return index > -1 ? index : layerOrder.length;
}

export const NewMeasureLegendLayer = { groupTitle: layerGroupTitleMeasures, title: "Noch nicht gespeicherte Maßnahme", id: NEW_MEASURES_ID, visible: true,isTwoD: true,loaded: true, order: getLayerOrderIndex(NEW_MEASURES_ID), color: MAP_COLORS.LILAC, isPoint: true};

const initialLayerGroups: Array<ILayerGroup> = [ 
  {
    title: layerGroupTitleMeasures,
    hideAllLayers: false,
    layer: [     
      { groupTitle: layerGroupTitleMeasures, title: "Zugeordnete Maßnahmen", id: EXISTING_MEASURES_ID, visible: true,isTwoD: true,loaded: true, order: getLayerOrderIndex(EXISTING_MEASURES_ID), color: MAP_COLORS.BURGUNDYPLUM, isPoint: true}, 
      { groupTitle: layerGroupTitleMeasures, title: "Andere Maßnahmen", id: OTHER_EXISTING_MEASURES_ID, visible: true,isTwoD: true,loaded: true, order: getLayerOrderIndex(OTHER_EXISTING_MEASURES_ID), color: MIKE_COLORS.ACTIONBLUE_DARK, isPoint: true} 
    ]
  }       
]

export default initialLayerGroups